import { render, staticRenderFns } from "./dialog-check-admin-business.vue?vue&type=template&id=46f4f0fc&"
import script from "./dialog-check-admin-business.vue?vue&type=script&lang=js&"
export * from "./dialog-check-admin-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports